module.exports = __webpack_public_path__ + "img/eco.5b9c6057.jpg";